<template>
  <div v-if="hasFieldsValue" class="double-text-container">
    <sc-text tag="h2" class="title" :field="fields.bodyTitle"/>
    <sc-rich-text tag="div" class="paragraph text-block rich-text-block" :field="fields.bodyText"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'DoubleText',
  props: {
    fields: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    ScRichText: RichText
  },
  computed: {
    ...mapJssGetters(['isEditMode']),

    hasFieldsValue () {
      return !!(this.isEditMode
        || get(this.fields, ['bodyTitle', 'value'])
        || get(this.fields, ['bodyText', 'value']))
    }
  }
}
</script>

<style lang="scss" scoped>

.double-text-container {
  padding: $d-med 0 $space-080;

  @include tablet {
    padding: $space-080 0 $space-090;
  }

  .title {
    @include font('080');

    font-weight: 600;
    color: $color_gray_2;
  }

  .paragraph {
    @include font('060');

    font-stretch: normal;
    letter-spacing: normal;
    color: $color_gray_2;

    @include tablet {
      margin-top: $space-060;
    }
  }
}
</style>
